import { apiGet } from '../js/api';
import Server from '../js/config/_server';

/**
 * Fetches all module types
 */
export const getModuleTypes = () => {
    const url = Server.baseUrl + Server.services.moduleTypes.getAll;
    return apiGet(url);
};
